import CityPageTemplate from "../city-template/CityPageTemplate";
import { moscowConfig } from "./data";

export default function MoscowPage() {
  return <CityPageTemplate config={moscowConfig} />;
}